<div class="services-page">


<div class="services-header">

    <div>

        <h1>
            My Services
        </h1>

        <p>
            Add and manage your wedding services
        </p>

    </div>


    <button
    class="add-service-btn"
    *ngIf="!(merchantData?.subscriptionTier === 'STANDARD' && services.length >= 3)"
    (click)="toggleAddForm()">

        + Add Service

    </button>
    <div *ngIf="merchantData?.subscriptionTier === 'STANDARD' && services.length >= 3" style="color: #B01E3E; font-weight: 600; text-align: right;">
        Standard Plan limit (3) reached. <br>
        <a routerLink="/merchant/subscription" style="color: #B01E3E; text-decoration: underline;">Upgrade to Premium</a>
    </div>


</div>





<div
class="service-form-card"
*ngIf="showAddForm">



<div class="form-title">

<h2>
Add Service
</h2>


<button
(click)="toggleAddForm()">

✕


</button>


</div>







<form
[formGroup]="serviceForm"
(ngSubmit)="addService()">







<!-- MEDIA UPLOAD -->


<label class="media-upload">


<input
type="file"
accept="image/*"
(change)="selectFiles($event)">



<div class="upload-box"
*ngIf="previewFiles.length===0">


<span>
+
</span>


<p>
Upload Service Profile Pic
</p>
</div>



</label>







<div
class="preview-grid"
*ngIf="previewFiles.length">


<div
class="preview-item"
*ngFor="let file of previewFiles;let i=index">


<img
*ngIf="file.type==='image'"
[src]="file.url">



<video
*ngIf="file.type==='video'"
[src]="file.url"
controls>
</video>



<button
type="button"
(click)="removeFile(i)">

×


</button>


</div>


</div>









<input
type="text"
placeholder="Service Name"
formControlName="service_name">







<select
formControlName="category">


<option value="">
Select Category
</option>


<option
*ngFor="let category of categories"
[value]="category._id">

{{category.name}}

</option>


</select>









<textarea
placeholder="Describe your service"
formControlName="description">
</textarea>







<input
type="number"
placeholder="Price"
formControlName="price">







<input
type="text"
placeholder="Duration Example: 2 Days"
formControlName="duration">







<textarea

placeholder="What's Included
Example:
Album, Drone, Video"

formControlName="included">

</textarea>









<!-- LOCATIONS -->


<div class="location-section">


<h3>
Available Locations
</h3>


<div class="location-input">


<input

type="text"

placeholder="Enter location"

[(ngModel)]="locationInput"

[ngModelOptions]="{standalone:true}"

>


<button
type="button"
(click)="addLocation()">

Add

</button>


</div>





<div class="chips">


<span
*ngFor="let loc of locations;let i=index">


{{loc}}


<button
type="button"
(click)="removeLocation(i)">

×


</button>


</span>


</div>


</div>









<!-- PAYMENT -->


<div class="payment-section">


<h3>
Payment Preference
</h3>



<select
[(ngModel)]="paymentType"

[ngModelOptions]="{standalone:true}"

(change)="paymentChanged()">


<option value="FULL_PAYMENT">
Full Payment
</option>


<option value="ADVANCE">
Advance Payment
</option>


<option value="POSTPAID">
Postpaid
</option>


<option value="CASH_ON_HAND">
Cash On Hand
</option>


</select>






<input
*ngIf="paymentType==='ADVANCE'"

type="number"

placeholder="Advance Amount"

[(ngModel)]="advanceAmount"

[ngModelOptions]="{standalone:true}"

>


</div>







<button
class="save-btn">

Save Service

</button>




</form>


</div>









<!-- SERVICE LIST -->


<div class="service-list">



<div
class="service-card"
*ngFor="let service of services">






<div class="service-image">


<img
*ngIf="service.media?.length"

[src]="imageBaseUrl + service.media[0].media_url">


</div>






<div class="service-content">


<h2>
{{service.service_name}}
</h2>



<p>
{{service.description}}
</p>




<div class="meta">

<p>
₹ {{service.price}}
</p>


<p>
{{service.category?.name}}
</p>


</div>






<div
class="locations"

*ngIf="service.service_locations?.length">


<strong>
Locations:
</strong>


<span
*ngFor="let loc of service.service_locations">

{{loc}}

</span>


</div>






<div
class="payment-display">


<strong>
Payment:
</strong>


{{service.payment?.type}}



</div>








<div class="actions">


<button
class="edit-btn"

(click)="editService(service._id)">

Edit

</button>




<button
class="delete-btn"

(click)="deleteService(service._id)">

Delete

</button>


</div>





</div>


</div>



</div>


</div>